import React, { useState } from 'react';
import { projectsData } from '../utils/constants';
import { ExternalLinkIcon } from 'lucide-react';
const Projects = ({
  language = 'en'
}) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const translations = {
    en: {
      featured: 'Featured',
      projects: 'Projects',
      learnMore: 'Learn More'
    },
    vi: {
      featured: 'Dự Án',
      projects: 'Nổi Bật',
      learnMore: 'Tìm Hiểu Thêm'
    }
  };
  const t = translations[language];
  // Project translations
  const projectTranslations = {
    en: projectsData,
    vi: projectsData.map(project => ({
      ...project,
      title: project.title === 'AidWorks Foundation' ? 'Quỹ AidWorks' : project.title === 'Northeastern Investment Banking Group' ? 'Nhóm Ngân Hàng Đầu Tư Northeastern' : project.title === 'Vu A Dinh Scholarship Fund' ? 'Quỹ Học Bổng Vừ A Dính' : project.title === 'Goldman Sachs 2025 Possibilities Summit' ? 'Hội Nghị Possibilities 2025 của Goldman Sachs' : project.title,
      role: project.role === 'Founder & CEO' ? 'Người Sáng Lập & CEO' : project.role === 'Vice President' ? 'Phó Chủ Tịch' : project.role === 'Deputy Chief External Relations Officer' ? 'Phó Giám Đốc Đối Ngoại' : project.role === 'Participant' ? 'Người Tham Gia' : project.role,
      description: project.title === 'AidWorks Foundation' ? 'Gây quỹ hơn $13,500 hàng năm để phục vụ hơn 3500 cá nhân thông qua hơn 120 tình nguyện viên đăng ký và 14+ đối tác tổ chức.' : project.title === 'Northeastern Investment Banking Group' ? 'Phục vụ trong tất cả các chức năng chính, phát triển câu lạc bộ lên hơn 30 thành viên tích cực và đào tạo hơn 40 sinh viên.' : project.title === 'Vu A Dinh Scholarship Fund' ? 'Quản lý $18M tiền quyên góp, duy trì hơn 120 đối tác doanh nghiệp, dẫn đầu 2 sự kiện lớn để hỗ trợ cựu chiến binh.' : project.title === 'Goldman Sachs 2025 Possibilities Summit' ? 'Được chọn cho chương trình độc quyền cung cấp cái nhìn sâu sắc về ngân hàng đầu tư và thị trường tài chính.' : project.description
    }))
  };
  const localizedProjects = projectTranslations[language];
  return <section id="projects" className="w-full py-24 bg-background" data-id="element-983">
      
    </section>;
};
export default Projects;